import { isSchoolStudentRole, isNonSchoolTeacherRole } from '../../utils/userAccessHelper';
import { resolveProfileStates } from '../../utils/function';

export const shouldRequireMyDraftsStateSelection = (profile) => {
  return isSchoolStudentRole(profile) && !resolveProfileStates(profile);
};

export const shouldRequireNonSchoolTeacherStateYearSelection = (profile) => {
  return isNonSchoolTeacherRole(profile) && !resolveProfileStates(profile);
};
